import { SIM_DT } from '@battle/shared';

/**
 * Fixed-timestep accumulator. The sim always advances in SIM_DT steps. Rendering interpolates
 * between the last two sim states with `alpha`.
 */
export interface FixedStep {
  /** Feed real elapsed seconds; returns how many sim steps to run now. */
  advance(elapsedSeconds: number): number;
  /** Interpolation factor in [0, 1) between the previous and current sim state. */
  readonly alpha: number;
}

/** Absorbs float drift so e.g. 2.5 + 0.5 steps of elapsed time yields exactly 3 steps. */
const EPSILON = 1e-9;

export function createFixedStep(dt = SIM_DT, maxStepsPerFrame = 8): FixedStep {
  let accumulator = 0;
  return {
    advance(elapsedSeconds) {
      // Clamp long stalls (tab switches) so the sim never spirals trying to catch up.
      accumulator += Math.min(Math.max(elapsedSeconds, 0), dt * maxStepsPerFrame);
      let steps = 0;
      while (accumulator + EPSILON >= dt && steps < maxStepsPerFrame) {
        accumulator = Math.max(accumulator - dt, 0);
        steps++;
      }
      return steps;
    },
    get alpha() {
      return accumulator / dt;
    },
  };
}
